module.exports = __webpack_public_path__ + "static/logo-bcf1ae7f565d0e8f0d07a2ab0f777cfb.png";